import { createSelector } from 'reselect';

export const currentRouteName = (state) => state.routing.name;
export const currentRouteData = (state) => state.routing.data;
